import CardLayout from "../Layout/CardLayout";
import React, { useState, useEffect } from "react";
import TableVertical from "../Util/TableVertical";
import Ranked from "../Ciem/Ranked";
import axiosInstance from "../../../api/api";

const CapacidadInstalada = (ciemId) => {
    const [rankedForm, setRankedForm] = useState([]);

    useEffect(() => {
        axiosInstance.get('/detailoption/option/value/rankedEight').then((response) => {
            console.log("Calificación obtenida:", response.data.data[0]);
            setRankedForm(response.data.data[0]);
        }).catch((e) => {
            alert("Error consultando la calificacion " + e)
        });
    }, []);

    const contributionForm =
        <TableVertical optionName={"capacidadInstaladaTable"}
                  ciemId={ciemId}
                       editable={true}
        />
    ;

    const calificacion = <Ranked field={rankedForm} ciemId={ciemId.ciemId} />

    return (
        <div className="container-fluid">
            <CardLayout value={"capacidadInstaladaTitulo"} tablaComponent={contributionForm} />
            <CardLayout value={"rankedEight"} tablaComponent={calificacion} />
        </div>
    );
};
export default CapacidadInstalada;